import error from "../images/Maintenance.png";
import logo from "../images/logo.svg";
// import EciNetLogo from "../images/ecinet_logo.png";
function UnderMaintainance() {
  return (
    <>
      <div className="justify-content-center mt-2" style={{ display: "flex" }}>
        <img src="/ECINet-logo.png" height="75px" alt="" />
        <div
          className="logo-text1"
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "20px",
            fontWeight: "500",
            color: "#00357D",
          }}
        >
          <span
            className="logo-text-font-size pl-2"
            style={{ fontSize: "25px" }}
          >
            {"  "} ECINet
          </span>
          <div className="ml-2" style={{borderLeft:"1px solid #e1d8d8", height:"75px"}}></div>
        </div> &nbsp;
        <img src={logo} alt="" />
        <div
          className="logo-text1"
          style={{
            display: "flex",
            alignItems: "center",
            fontSize: "20px",
            fontWeight: "500",
            color: "#00357D",
          }}
        >
          <span
            className="logo-text-font-size"
            style={{ fontSize: "25px" }}
          >
            {"  "} Election Commission of India
          </span>
        </div>
        {/* <div className="justify-content-center" style={{ display: "flex"}}> */}
      </div>

      <div className="style-width-maintainance  ">
        {/* <img
          src={error}
          alt="error"
          className="flex-container-maintainance mb-3"
        ></img> */}
       <div className="flex-container-maintainance">
        <div className=" text-center mr-0">
            <img
          src={error}
          alt="error"
          height="160px"
          // style={{ transform: "rotate(45deg)"}}
          // className="flex-container-maintainance mb-3"
        ></img>
        </div>
        <div className=" col-7 mt-4" style={{marginTop:7}}>
 <p className="flex-container-maintainance px-2" style={{fontSize:25}}>
          Our system is undergoing essential maintenance activities.The services
          will resume shortly after completion of the maintenance.
        </p>
        </div>
       </div>
       
      </div>
    </>
  );
}
export default UnderMaintainance;
